export const isFavoritePassengersEnabled = () => {
  try {
    const flag = localStorage.getItem('favorite_passengers_flag');

    return flag === 'true';
  } catch (error) {
    return false;
  }
};
